import { render, staticRenderFns } from "./AiProductRequests.vue?vue&type=template&id=46f82144&scoped=true"
import script from "./AiProductRequests.vue?vue&type=script&lang=js"
export * from "./AiProductRequests.vue?vue&type=script&lang=js"
import style0 from "./AiProductRequests.vue?vue&type=style&index=0&id=46f82144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f82144",
  null
  
)

export default component.exports